import { create } from '../../../../services/api';

export default (episodeId, duration) =>
  create
    .get(`/api-v3/episodes/${episodeId}/audio-wizard-url`)
    .query({ duration })
    .then(response => {
      window.open(response.body.redirectUrl, '_blank', 'noopener');
    });
